class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimer = null;
    this.hoverMediaQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');

    const summary = this.mainDetailsToggle.querySelector('summary');

    // クリック操作もSPのアコーディオンと同じ高さアニメーションで開閉したいため、
    // ネイティブのopen/close（瞬時に切り替わる）は使わず、open属性の付け外しを
    // すべてこちらのopen()/close()経由でJSから行う。
    if (summary) {
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.close();
        } else {
          this.open();
        }
      });
    }

    if (this.hoverMediaQuery.matches) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
  }

  // 1階層目にカーソルを当てるだけでドロップダウンを表示する。
  onMouseEnter() {
    if (this.hoverCloseTimer) {
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = null;
    }
    this.open();
  }

  onMouseLeave() {
    this.hoverCloseTimer = setTimeout(() => {
      this.close();
    }, 150);
  }

  // ドロップダウンの表示位置：上端をヘッダー全体の下端に、左端をこのメニュー
  // 項目自体の左端に揃える（position: fixed + JS計測。メニュー項目ごとに
  // 高さがまちまちな中でも、ヘッダーの下端に正確に揃えるため）。
  positionSubmenu() {
    if (!this.header) return;
    const submenu = this.content;
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!submenu || !summary) return;

    const headerRect = this.header.getBoundingClientRect();
    const summaryRect = summary.getBoundingClientRect();

    submenu.style.position = 'fixed';
    submenu.style.top = `${Math.floor(headerRect.bottom)}px`;
    submenu.style.left = `${Math.floor(summaryRect.left)}px`;
  }

  // SPのハンバーガーメニューと同じ「高さ0→実寸→auto」で開き、
  // 「実寸→0」で閉じるアニメーション（開く時は上端固定で下に伸び、
  // 閉じる時は下端から縮む見え方になる）。
  open() {
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');

    this.positionSubmenu();

    const submenu = this.content;
    if (!submenu) return;
    submenu.style.boxShadow = '';
    submenu.style.height = '0px';
    requestAnimationFrame(() => {
      submenu.style.height = `${submenu.scrollHeight}px`;
    });

    const onOpenEnd = (evt) => {
      if (evt.propertyName !== 'height') return;
      submenu.style.height = 'auto';
      submenu.removeEventListener('transitionend', onOpenEnd);
    };
    submenu.addEventListener('transitionend', onOpenEnd);
  }

  close() {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    const summary = this.mainDetailsToggle.querySelector('summary');
    const submenu = this.content;

    if (!submenu) {
      this.mainDetailsToggle.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      return;
    }

    submenu.style.height = `${submenu.scrollHeight}px`;
    submenu.style.boxShadow = 'none';
    void submenu.offsetHeight;
    requestAnimationFrame(() => {
      submenu.style.height = '0px';
    });

    const onCloseEnd = (evt) => {
      if (evt.propertyName !== 'height') return;
      this.mainDetailsToggle.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      submenu.removeEventListener('transitionend', onCloseEnd);
    };
    submenu.addEventListener('transitionend', onCloseEnd);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) this.positionSubmenu();

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
